/** Metadata-only notification contracts shared by UI and server. */
export const NOTIFICATION_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export type NotificationEntity = "issue" | "doc" | "note";
export type NotificationPreferenceKind = "assignment" | "review" | "comment" | "mention";
export type NotificationKind = NotificationPreferenceKind | "reply" | "done" | "canceled" | "reopened" | "blocked" | "status_change" | "following_comment";
export type NotificationSection = "needs_me" | "my_requests" | "following";
export type NotificationSnoozeFilter = "active" | "snoozed" | "all";
export const notificationPreferenceKinds: readonly NotificationPreferenceKind[] = ["assignment", "review", "mention", "comment"];
export type NotificationDeliveryStatus = "pending" | "sending" | "sent" | "failed" | "unknown" | "canceled";
export type PersonalNotification = {
  id: string; entityType: NotificationEntity; entityId: string; kind: NotificationKind;
  title: string; identifier: string | null; href: string; createdAt: string; readAt: string | null;
  section: NotificationSection;
  actor: { id: string; name: string; isBot: boolean } | null;
  snoozedUntil: string | null; following: boolean;
  delivery: { status: NotificationDeliveryStatus; attempts: number; error: string | null } | null;
};
export type PersonalNotificationsPage = {
  items: PersonalNotification[]; unreadCount: number; slackEnabled: boolean; slackConnected: boolean;
  kinds: Record<NotificationPreferenceKind, boolean>;
  cursor: { before: string; beforeId: string } | null;
};
export const notificationReason: Record<NotificationKind, string> = {
  assignment: "Tarefa atribuída a você", review: "Sua revisão foi solicitada",
  comment: "Novo comentário", mention: "Você foi mencionado",
  reply: "Responderam ao seu comentário", done: "Tarefa concluída", canceled: "Tarefa cancelada",
  reopened: "Tarefa reaberta", blocked: "Bloqueio registrado", status_change: "Estado da tarefa alterado",
  following_comment: "Comentário em tarefa acompanhada",
};
export const notificationDeliveryLabel: Record<NotificationDeliveryStatus, string> = {
  pending: "Slack: aguardando envio", sending: "Slack: envio em andamento", sent: "Slack: enviado",
  failed: "Slack: envio não realizado", unknown: "Slack: resultado desconhecido; sem reenvio automático",
  canceled: "Slack: envio cancelado",
};
export function personalNotificationHref(slug: string, kind: NotificationEntity, id: string): string {
  return `/${encodeURIComponent(slug)}?${kind}=${encodeURIComponent(id)}`;
}
/** Only an explicit UUID token is a human mention; names are display-only. */
export function humanMentionToken(user: { id: string; name: string }): string | null {
  if (!NOTIFICATION_UUID.test(user.id)) return null;
  const name = user.name.replace(/[\[\]\r\n\\]/g, " ").trim().slice(0, 100) || "Pessoa";
  return `@[${name}](pauta:user:${user.id})`;
}
export function humanMentionIds(body: string): string[] {
  const pattern = /@\[[^\]\r\n]{1,100}\]\(pauta:user:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\)/gi;
  return [...new Set([...body.matchAll(pattern)].map((match) => match[1].toLowerCase()))];
}
